import { Nullable } from '@/shared/types/app.types'
import { ConfigurationSectionResponse } from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/configuration-section/configuration-section.dto'
import { CommonSubportionTypeResponse } from '@/api/services/common/subportion-type/common-subportion-type.dto'

export interface SubportionStateMachineConfigurationModalState {
    filePath: string
    id: Nullable<number>
    section: Nullable<ConfigurationSectionResponse>
    subportionType: Nullable<CommonSubportionTypeResponse>
    sectionIdFromParams?: Nullable<number>
}
export const initialSubportionStateMachineConfigurationModalState =
    (): SubportionStateMachineConfigurationModalState => ({
        filePath: '',
        id: null,
        section: null,
        subportionType: null,
        sectionIdFromParams: null
    })
